module.exports = __webpack_public_path__ + "media/images/question_examples/question-example-landing-page-daaabc69f821bd80873604e0d54a7e59.png";